import {
  Backdrop,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Input,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Select,
  Typography,
  Dialog
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import axios from 'src/utils/axios';
import { getUser, sc } from 'src/utils/Common';
import { setMalzemeIhtiyacAdet } from 'src/utils/storage/NavBarAdet';

const useStyles = makeStyles(theme => ({
  root: {},
  contentMI: {
    padding: 0
  },
  backdropMI: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  searchMI: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconMI: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInputMI: {
    flexGrow: 1
  }
}));
function Todos({ className, ...rest }) {
  const classes = useStyles();
  const { t } = useTranslation('material_requirement');
  const [todos, setTodos] = useState([]);
  const [Loading, setLoading] = useState(true);
  const [todosData, setTodosData] = useState([]);
  const SessionUser = getUser();
  var TitleApp = "Sirius Partner";
  const history = useHistory();
  const [stateDurum, setStateDurum] = useState('');
  const [stateGun, setStateGun] = useState('Bugün');
  const [title, setTitle] = useState(TitleApp);
  const [ImagePopup, setImagePopup] = useState(false);
  const [ImageUrl, setImageUrl] = useState('');

  const handleChangeGun = event => {
    setStateGun(event.target.value);
    switch (event.target.value) {
      case 'Öneri':
        setTitle(t('Akilli_oneri'));
        break;
      case 'Hurda':
        setTitle(t('iade_Edilecek_Malzemeler'));
        break;
      default:
        setTitle(t('title'));
    }
  };

  useEffect(() => {
    let todosData1 = [];
    todosData1 = todos.filter(d => d.Day === stateGun);
    setTodosData(todosData1);
    // eslint-disable-next-line
  }, [stateGun]);

  const malzemeKoduAra = (malzemeler, search) => {
    for (let i = 0; i < malzemeler.length; i++) {
      if (
        sc(malzemeler[i].MaterialCode, search) ||
        sc(malzemeler[i].Material, search)
      )
        return true;
    }
    return false;
  };

  useEffect(() => {
    let todosData1 = [];
    todosData1 = todos.filter(function (item) {
      return (
        sc(item.FisNo, stateDurum) ||
        malzemeKoduAra(item.MALZEMELER, stateDurum)
      );
    });
    setTodosData(todosData1);
    // eslint-disable-next-line
  }, [stateDurum]);

  const BirimKodu = SessionUser.ServiceShopId;
  const TeknisyenKodu = SessionUser.TechnicianId;

  useEffect(() => {
    let mounted = true;
    const fetchTodos = () => {
      axios
        .get(`/GetSiriusOpenMaterials/${BirimKodu}/${TeknisyenKodu}`)
        .then(response => {
          if (mounted) {
            const Deger = response.data;
            if (Deger.length === 0) {
              setTodos([]);
              setTodosData([]);
            } else {
              const DegerData = Deger.filter(d => d.Day === 'Bugün');
              setTodos(Deger);
              setTodosData(DegerData);
            }
            let Adet = 0;
            Deger &&
              Deger.map(d => {
                return (Adet += d.Materials.length);
              });
            setMalzemeIhtiyacAdet(Adet);
            setLoading(false);
          }
        })
        .catch(error => {
          setMalzemeIhtiyacAdet(0);
          setLoading(false);
        });
    };
    fetchTodos();
    return () => {
      mounted = false;
    };
  }, [BirimKodu, TeknisyenKodu]);

  const malzemeGosterMI = materialCode => {
    const dataMI = {
      MaterialCode: materialCode
    };
    const configMI = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/FileImportExport/SiriusMaterialImage', dataMI, configMI)
      .then(response => {
        const fileURLMI = URL.createObjectURL(response.data);
        // newWindow.location = fileURLMI;
        // newWindow.document.title = materialCode;
        setImageUrl(fileURLMI);
        setImagePopup(true);
      })
      .catch(error => { });
  };

  return (
    <div>
      {window.navigator.onLine && (
        <div className={clsx(classes.root, className)}>
          <Card>
            <Paper className={classes.searchMI} elevation={1}>
              <SearchIcon className={classes.searchIconMI} />
              <Input
                className={classes.searchInputMI}
                disableUnderline
                value={stateDurum}
                onChange={e => setStateDurum(e.target.value)}
                placeholder={t('Arama_Yap')}
              />
              <Select
                native
                value={stateGun}
                onChange={handleChangeGun}
                disableUnderline
                className={classes.input}
                label="Gun"
              >
                <option value="Bugün" defaultValue>
                  {t('Bugun')}
                </option>
                <option value="Yarın">{t('Yarın')}</option>
                <option value="Öneri">{t('Akilli_oneri')}</option>
                <option value="Hurda">{t('Hurda_iade')}</option>
              </Select>
            </Paper>
            <CardHeader title={title} />
            <Divider />
            {Loading ? (
              <Backdrop className={classes.backdropMI} open={Loading}>
                <CircularProgress color="inherit" />
              </Backdrop>
            ) : (
              <div />
            )}
            <CardContent className={classes.contentMI}>
              <List className={classes.root}>
                {todosData
                  .sort(t => t.Row)
                  .map(logMI => (
                    <div key={logMI.WorkOrderId}>
                      <ListItem alignItems="flex-start">
                        <ListItemAvatar>
                          <div align="center">
                            <Typography
                              component="span"
                              variant="h6"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {logMI.TimeSlot1}
                            </Typography>
                            <br />
                          </div>
                        </ListItemAvatar>
                        <ListItemText
                          primary={
                            <Typography
                              onClick={() => {
                                logMI.WorkOrderId?.toString()?.length === 9 &&
                                  history.push(
                                    `/WorkOrder/${logMI.WorkOrderId}/summary`
                                  );
                              }}
                              variant="h6"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {`${logMI.WorkOrderId?.toString()?.length === 9
                                  ? logMI.WorkOrderId
                                  : ''
                                } ${logMI.Consumer}`}
                            </Typography>
                          }
                          secondary={logMI.Materials.map((m, i) => (
                            <Typography
                              key={m.MaterialId}
                              variant="body1"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              <b>
                                {['Talep', 'Zimmet'].indexOf(logMI.Day) ===
                                  -1 && `${(i + 1).toString()} - `}{' '}
                                {m.MaterialCode}
                              </b>{' '}
                              {m.Material}{' '}
                              <b>
                                {`(${t('Adet')}: ${m.Quantity.toString()})`}
                              </b>
                              <ImageSearchIcon
                                color="primary"
                                onClick={() => malzemeGosterMI(m.MaterialCode)}
                              />
                            </Typography>
                          ))}
                        />
                      </ListItem>
                      <Divider variant="inset" component="li" />
                    </div>
                  ))}
              </List>
            </CardContent>
            <Dialog
              open={ImagePopup}
              fullWidth
              maxWidth="sm"
              onClose={() => setImagePopup(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <img width="auto" height="auto" src={ImageUrl} style={{ border: 'none' }} onclick={() => setImagePopup(false)}></img>
            </Dialog>
          </Card>
        </div>
      )}
    </div>
  );
}

Todos.propTypes = {
  className: PropTypes.string
};

export default Todos;
